// API Base URL
 
const API_BASE_URL = window.location.hostname === 'localhost' ? `http://localhost:3001/api` : '/api' || 'http://localhost:3001/api';

// Auth Functions
export const login = async (username, password) => {
  const response = await fetch(`${API_BASE_URL}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password })
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Login failed');
  }

  if (data.success && data.data) {
    localStorage.setItem('token', data.data.token);
    localStorage.setItem('user', JSON.stringify(data.data.user));
    return { token: data.data.token, user: data.data.user };
  }

  throw new Error('Invalid response from server');
};

// API Functions
const getAuthToken = () => localStorage.getItem('token');

const fetchWithAuth = async (url, options = {}) => {
  const token = getAuthToken();
  
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE_URL}${url}`, {
    ...options,
    headers
  });

  const data = await response.json();

  if (!response.ok) {
    if (response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.reload();
    }
    throw new Error(data.message || 'Request failed');
  }

  return data;
};

export const getLicenses = async () => {
  const response = await fetchWithAuth('/licenses');
  return response.data || [];
};

export const getApplications = async () => {
  const response = await fetchWithAuth('/applications');
  return response.data || [];
};

export const createLicense = async (licenseData) => {
  const response = await fetchWithAuth('/licenses', {
    method: 'POST',
    body: JSON.stringify(licenseData)
  });
  return response.data;
};

export const createOrganisation = async (orgData) => {
  const response = await fetchWithAuth('/organisations', {
    method: 'POST',
    body: JSON.stringify(orgData)
  });
  return response.data;
};

export const getCustomerHistory = async (id, type = 'individual') => {
  const response = await fetchWithAuth(`/customers/${id}/history?type=${type}`);
  return response.data;
};

export const addOrganisationSystem = async (orgId, { systemName }) => {
  const response = await fetchWithAuth(`/organisations/${orgId}/systems`, {
    method: 'POST',
    body: JSON.stringify({ systemName }),
  });
  return response.data;
};

export const createOrganisationSystemLicense = async (orgId, systemId, payload) => {
  const response = await fetchWithAuth(`/organisations/${orgId}/systems/${systemId}/license`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  return response.data;
};

export const approveOrgRequests = async (payload) => {
  const response = await fetchWithAuth('/license-requests/approve-org', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
  return response.data;
};

export const unbindDevice = async (licenseId) => {
  const response = await fetchWithAuth(`/licenses/${licenseId}/unbind`, {
    method: 'POST'
  });
  return response.data;
};

export const updateLicenseStatus = async (licenseId, status) => {
  const response = await fetchWithAuth(`/licenses/${licenseId}/status`, {
    method: 'PATCH',
    body: JSON.stringify({ status })
  });
  return response.data;
};

export const markLicenseInactive = async (licenseId) => {
  const response = await fetchWithAuth(`/licenses/${licenseId}/inactive`, {
    method: 'PATCH'
  });
  return response.data;
};

export const extendLicense = async (licenseId, additionalDays) => {
  const response = await fetchWithAuth(`/licenses/${licenseId}/extend`, {
    method: 'POST',
    body: JSON.stringify({ additionalDays })
  });
  return response.data;
};

export { fetchWithAuth };